module.exports = __webpack_public_path__ + "static/media/Icon-material-bookmark-border.488ea374.svg";